/* Eve's Skin — UI interactions (Shopify theme) */
(function () {
  'use strict';

  /* star injector */
  document.querySelectorAll('.stars[data-n]').forEach(function (s) {
    var n = parseInt(s.getAttribute('data-n'), 10) || 5, html = '';
    for (var i = 0; i < n; i++) html += '<svg viewBox="0 0 24 24"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.2 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
    s.innerHTML = html;
  });

  /* page load */
  window.addEventListener('load', function () { document.body.classList.add('loaded'); });
  setTimeout(function () { document.body.classList.add('loaded'); }, 1800);

  /* header: solid on scroll + hide on scroll-down */
  var stack = document.querySelector('.header-stack'), lastY = window.scrollY;
  function onScroll() {
    if (!stack) return;
    var y = window.scrollY;
    stack.classList.toggle('scrolled', y > 24);
    if (y > 480 && y > lastY + 8) stack.classList.add('hidden');
    else if (y < lastY - 8 || y < 140) stack.classList.remove('hidden');
    lastY = y;
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* reveal on scroll */
  var io = null;
  if ('IntersectionObserver' in window) {
    document.documentElement.classList.add('animations-ready');
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.rv, .rv-scale, .pullquote').forEach(function (el) { io.observe(el); });
    document.querySelectorAll('[data-stagger]').forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.classList.add('rv'); child.style.transitionDelay = (i * 90) + 'ms'; io.observe(child);
      });
    });
    /* Never leave content invisible if an observer is interrupted by an app/script. */
    setTimeout(function () { document.documentElement.classList.remove('animations-ready'); }, 4500);
  }

  /* counters */
  document.querySelectorAll('[data-count]').forEach(function (el) {
    if (el.closest('.br')) return; /* reviews own decimal-aware counter */
    var target = parseInt(el.getAttribute('data-count'), 10), done = false;
    if (!('IntersectionObserver' in window)) { el.textContent = target.toLocaleString(); return; }
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !done) {
          done = true; var t0 = null;
          var step = function (ts) { if (!t0) t0 = ts; var p = Math.min((ts - t0) / 1400, 1);
            el.textContent = Math.round(target * (1 - Math.pow(1 - p, 4))).toLocaleString();
            if (p < 1) requestAnimationFrame(step); };
          requestAnimationFrame(step); cio.disconnect();
        }
      });
    }, { threshold: 0.6 });
    cio.observe(el);
  });

  /* ---------- drawers ---------- */
  var drawer = document.getElementById('cartDrawer');
  var wishDrawer = document.getElementById('wishDrawer');
  var menuDrawer = document.getElementById('menuDrawer');
  var overlay = document.getElementById('cartOverlay');

  function openPanel(el) { if (!el) return; closePanels(); el.classList.add('open'); if (overlay) overlay.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closePanels() {
    [drawer, wishDrawer, menuDrawer].forEach(function (d) { if (d) d.classList.remove('open'); });
    if (overlay) overlay.classList.remove('open'); document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-open-cart]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openPanel(drawer); }); });
  document.querySelectorAll('[data-open-wish]').forEach(function (b) { b.addEventListener('click', function () { openPanel(wishDrawer); }); });
  document.querySelectorAll('[data-open-menu]').forEach(function (b) { b.addEventListener('click', function () { openPanel(menuDrawer); }); });
  if (menuDrawer) menuDrawer.addEventListener('click', function (e) { if (e.target.closest('a')) closePanels(); });
  document.querySelectorAll('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closePanels); });
  if (overlay) overlay.addEventListener('click', closePanels);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* toast */
  var toastEl = document.getElementById('toast'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    if (msg) toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------- wishlist (local) ---------- */
  var WISH_KEY = 'eves_wish_v1';
  function loadWish() { try { var v = JSON.parse(localStorage.getItem(WISH_KEY)); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
  var wish = loadWish();
  var wishItemsEl = document.getElementById('wishItems');
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function badge(sel, qty) {
    document.querySelectorAll(sel).forEach(function (el) { el.textContent = qty; el.classList.remove('pulse'); void el.offsetWidth; el.classList.add('pulse'); setTimeout(function () { el.classList.remove('pulse'); }, 400); });
  }
  function renderWish() {
    badge('.wish-count', wish.length);
    document.querySelectorAll('.wish[data-wish]').forEach(function (b) { b.classList.toggle('on', wish.some(function (w) { return String(w.id) === String(b.getAttribute('data-id')); })); });
    if (wishItemsEl) {
      wishItemsEl.innerHTML = wish.length ? wish.map(function (i, idx) {
        return '<div class="cart-item"><a href="' + esc(i.url || '#') + '"><img src="' + esc(i.img) + '" alt="' + esc(i.name) + '"></a><div><a class="nm" href="' + esc(i.url || '#') + '">' + esc(i.name) + '</a></div><button class="rm" data-wrm="' + idx + '">Remove</button></div>';
      }).join('') : '<div class="wish-empty">Nothing saved yet.<br>Tap the heart on any product.</div>';
    }
    try { localStorage.setItem(WISH_KEY, JSON.stringify(wish)); } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var wbtn = e.target.closest('.wish[data-wish]');
    if (wbtn) {
      e.preventDefault(); e.stopPropagation();
      var id = wbtn.getAttribute('data-id');
      var name = wbtn.getAttribute('data-name');
      var idx = wish.findIndex(function (w) { return String(w.id) === String(id); });
      if (idx > -1) wish.splice(idx, 1);
      else wish.push({ id: id, name: name, url: wbtn.getAttribute('data-url'), img: wbtn.getAttribute('data-img') });
      renderWish();
    }
  });
  if (wishItemsEl) wishItemsEl.addEventListener('click', function (e) {
    var t = e.target.closest('[data-wrm]'); if (t) { wish.splice(+t.getAttribute('data-wrm'), 1); renderWish(); }
  });
  renderWish();

  /* expose for cart.js */
  window.EvesUI = { openCart: function () { openPanel(drawer); }, close: closePanels, toast: toast, badge: badge };
})();
